<template>
  <div>
    <div class="list-area" v-if="ready">
      <div v-if="noData" class="no-contents">조회 결과가 없습니다</div>
      <vertical-list-slider
        :listItems="listItems"
        :componentStyle="componentStyle"
        :isActiveVue="isActiveVue"
      ></vertical-list-slider>
    </div>
  </div>
</template>

<script>
import VerticalListSlider from "../components/slider/VerticalListSlider.vue";

export default {
  data() {
    return {
      isActiveVue: true,
      componentStyle: {
        left: Number(window.innerWidth) == 1920 ? "176px" : "120px",
        width: Number(window.innerWidth) == 1920 ? "242px" : "168px",
        height: Number(window.innerWidth) == 1920 ? "312px" : "210px",
      },
      ready: false,
      noData: false,
    };
  },
  computed: {
    listItems() {
      return this.$store.getters.gameTypes;
    },
    focusedView() {
      return this.$store.getters.focusedView;
    },
  },
  watch: {
    focusedView(val) {
      if (this.isActiveVue == true && val == "default" && this.noData == true) {
        this.$store.commit("SET_FOCUSED_VIEW", "gnb");
      }
    },
  },
  components: {
    VerticalListSlider,
  },

  async created() {
    this.$store.commit("SET_FOCUSED_VIEW", "default");
    this.$store.commit("REMOVE_GAME_TYPE");
    this.$progress.$emit("on:progress");

    try {
      const response = await this.$store.dispatch("FETCH_GAME_TYPE");

      if (!response.data || response.data.length === 0) {
        this.noData = true;
        this.ready = true;
        return;
      }

      response.data.forEach((gameType, index) => {
        gameType.seqNo = index;
      });

      const promises = response.data.map((gameType) =>
        this.$store.dispatch("FETCH_LEAGUE_DATA_BY_TYPEID", gameType)
      );

      await Promise.all(promises);
      this.ready = true;
    } catch (error) {
      console.error("데이터 로드 오류", error);
      this.noData = true;
      this.ready = true;
    } finally {
      this.$progress.$emit("off:progress");
    }
  },
  activated() {
    this.isActiveVue = true;
  },
  deactivated() {
    this.isActiveVue = false;
  },
};
</script>

<style scoped>
.list-area {
  position: relative;
}
.no-contents {
  font-size: 32px;
  left: 650px;
  top: 460px;
  width: 400px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  background-color: rgba(30, 30, 30, 0.95);
}

@media all and (min-width: 0px) and (max-width: 1280px) {
  .no-contents {
    font-size: 32px;
    left: 50%;
    top: 330px;
    width: 400px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    background-color: rgba(30, 30, 30, 0.95);
    transform: translateX(-50%);
  }
}
</style>
